import React from 'react';
import { Input } from '@roger/ui-components';
import { Question } from '../types';
import { getNumericInputMin } from '../valueConstraints';

interface NumberQuestionProps {
  question: Question;
  value: number | string;
  onChange: (value: number | string) => void;
  disabled?: boolean;
}

export const NumberQuestion: React.FC<NumberQuestionProps> = ({
  question,
  value,
  onChange,
  disabled = false,
}) => {
  const constraints = question.value_constraints;

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const inputValue = e.target.value;

    // Allow empty string for clearing the field
    if (inputValue === '') {
      onChange('');
      return;
    }

    // Convert to number if valid
    const numValue = parseFloat(inputValue);
    if (!isNaN(numValue)) {
      onChange(numValue);
    }
  };

  return (
    <div className='space-y-2'>
      <label className='text-sm font-semibold text-foreground block'>
        {question.question || question.description}
      </label>

      <Input
        type='number'
        value={value?.toString() || ''}
        onChange={handleChange}
        disabled={disabled}
        placeholder='0'
        inputSize='default'
        min={getNumericInputMin(constraints)}
      />
    </div>
  );
};
